module.exports = __webpack_public_path__ + "static/media/pharmacy-tech.eecf1c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/sliderPuzzle/pharmacy-tech.png
// module id = 525
// module chunks = 0